import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {InsolesProviderModelMaterialModel} from "./insolesProviderModelMaterial.model";
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {Injectable} from "@angular/core";
import {InsoleMaterialSummaryConverter} from "../../../../material/api/entity/insoleMaterialSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesProviderModelMaterialConverter extends HttpModelConverter<InsolesProviderModelMaterialModel>{

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private insoleMaterialSummaryConverter: InsoleMaterialSummaryConverter) {
        super();
    }

    protected createInstance(): InsolesProviderModelMaterialModel {
        return new InsolesProviderModelMaterialModel();
    }

    protected enrichObject(result: InsolesProviderModelMaterialModel, src: InsolesProviderModelMaterialModel) {
        result.material = this.insoleMaterialSummaryConverter.convert(src.material);
        result.colors = this.lovValueSummaryConverter.convertFromArray(src.colors);
    }

}